@if (context()) {
  @if (problem(); as problem) {
  <div class="bar error-brd sb-field__error sb-text-condition-hint__error">
    <div class="invalid-text">
      Conditional text {{ quote(problem.tag) }}: <span role="status">{{ problem.message }}</span>
      @if (problemCount() > 1) {
      <span>({{ problemCount() - 1 }} more)</span>
      }
      @if (target()) {
      <button
        type="button"
        class="sb-text-condition-hint__link"
        aria-label="Show the problem in the field"
        (click)="showProblem()">Show</button>
      }
    </div>
  </div>
  }

  @for (token of conditionalOnly(); track token) {
  <div class="sb-text-condition-hint__warning" role="status">
    {{ token }} is only inside conditional text, so anyone its conditions leave out gets this text without it.
  </div>
  }

  @if (!problem() && summaries().length) {
  <ul class="sb-text-condition-hint__list" aria-label="Conditional text in this field">
    @for (summary of summaries(); track summary; let i = $index) {
    <li class="sb-field__description sb-text-condition-hint__item">
      <svg class="sb-text-condition-icon sb-text-condition-hint__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <circle cx="6" cy="5" r="2" /><circle cx="18" cy="5" r="2" /><circle cx="12" cy="19" r="2" />
        <path d="M6 7v2a3 3 0 003 3h6a3 3 0 003-3V7" /><path d="M12 12v5" />
      </svg>
      <span>{{ summary.text }}</span>
      @if (target() && !disabled()) {
      <button
        type="button"
        class="sb-text-condition-hint__link"
        [attr.aria-label]="'Edit conditional text ' + (i + 1)"
        (click)="edit(summary)">Edit</button>
      }
    </li>
    }
    @if (moreBlocks(); as moreBlocks) {
    <li class="sb-field__description">And {{ moreBlocks }} more conditional {{ moreBlocks === 1 ? 'text' : 'texts' }}.</li>
    }
  </ul>
  }

}
